import RequestService, { getQueryURL } from '../requestService';
import { client } from '../../client';
import { MessageRequiredAnswer } from '../../../models/messageRequiredAnswer';
import { Referansekode } from '../../../models';

export default class ReferansekodeService extends RequestService<Referansekode, 'referansekode'> {
    importFromXML = async (fileContent: Blob, filNavn: string) => {
        const buffer = await fileContent.arrayBuffer();
        const res = await client.post<MessageRequiredAnswer>(getQueryURL(`${this.serviceName}/import`, { filNavn }), buffer);
        return { success: true, msg: res.message };

    };
    eksportTilXml = async (id?: Referansekode['id']) => await client.getFile(`${this.serviceName}/${id ? encodeURIComponent(id) + '/' : ''}xml-eksport`, 'GET');
}
